export const TAG_VALIDATION_FAIL = 'Each tag value should have at least {minLength} characters'
